/* eslint-disable */
import createIcon from '../createIcon';

const IconCaretDownOutlined = createIcon({
  name: 'icon-caret-down-outlined',
  content: '<path fill="currentColor" d="M768 349H256l256 325z" fill-rule="evenodd"/>',
  width: 1024,
  height: 1024
});
export default IconCaretDownOutlined;
